import { toast } from "react-toastify";
import { CART_ADD_ITEM, CART_REMOVE_ITEM, CART_UPDATE_QUANTITIES, CART_SET_ITEMS, CLEAR_CART } from "./cartActionTypes";
import api from "../../api/api";
import { logoutUser } from "../user";
import shopApi from "../../api/shop";

export function cartAddItemSuccess(product, options = [], quantity = 1) {
    toast.success(`Product "${product.name}" added to cart!`, { theme: "colored" });

    return {
        type: CART_ADD_ITEM,
        product,
        options,
        quantity,
    };
}

export function cartRemoveItemSuccess(itemId) {
    return {
        type: CART_REMOVE_ITEM,
        itemId,
    };
}

export function cartUpdateQuantitiesSuccess(quantities) {
    return {
        type: CART_UPDATE_QUANTITIES,
        quantities,
    };
}

export const setCartItems = (cart) => ({
    type: CART_SET_ITEMS,
    payload: cart,
});

export const fetchUserCart = (userId, locale) => async (dispatch, getState) => {
    try {
        const state = getState();
        const token = state?.user.userConnected.accessToken;

        const response = await api.get(`cart/${userId}?lang=${locale}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        dispatch(setCartItems(response.data.products, `response.data.products`));
    } catch (error) {
        console.error("Error fetching cart:", error);
    }
};

export function cartAddItem(product, options = [], quantity = 1) {
    const productId = product.id;
    return async (dispatch, getState) => {
        try {
            const state = getState();
            const token = state?.user?.userConnected?.accessToken;
            const refreshToken = state?.user?.userConnected?.refreshToken;
            const userId = state?.user?.userConnected?.user?.id;

            if (token) {
                // Vérification si le token a expiré
                const isTokenExpired = checkTokenExpiration(refreshToken);
                if (isTokenExpired) {
                    toast.error("Votre session a expiré. Veuillez vous reconnecter.", {
                        theme: "colored",
                        autoClose: 20000,
                    });
                    shopApi.logout(refreshToken);
                    return;
                }

                // User is logged in, proceed with the API request
                const response = await api.post(
                    "cart/add",
                    { userId, productId, options, quantity },
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );

                if (response.status === 201) {
                    dispatch(cartAddItemSuccess(product, options, quantity));
                }
            } else {
                // User is not logged in, store cart in localStorage
                const cart = JSON.parse(localStorage.getItem("cart")) || [];
                const existingItemIndex = cart.findIndex(
                    (item) => item.productId === productId
                );

                if (existingItemIndex !== -1) {
                    cart[existingItemIndex].quantity += quantity;
                } else {
                    cart.push({ productId, options, quantity });
                }

                localStorage.setItem("cart", JSON.stringify(cart));
                dispatch(cartAddItemSuccess(product, options, quantity));
            }
        } catch (error) {
            console.error("Error adding item to cart:", error);
        }
    };
}

// Fonction pour vérifier si le token a expiré
function checkTokenExpiration(refreshToken) {
    try {
        const payload = JSON.parse(atob(refreshToken.split(".")[1]));
        const currentTime = Math.floor(Date.now() / 1000);
        return payload.exp < currentTime;
    } catch (error) {
        console.error("Erreur lors de la vérification du token :", error);
        return true;
    }
}


export function cartRemoveItem(itemId) {
    return async (dispatch, getState) => {
        try {
            const state = getState();
            const token = state?.user?.userConnected?.accessToken;
            const userId = state?.user?.userConnected?.user?.id;

            if (token) {
                // Utilisateur connecté : suppression via l'API
                const response = await api.post(
                    "cart/remove",
                    { userId, itemId },
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );

                if (response.status === 200) {
                    dispatch(cartRemoveItemSuccess(itemId));
                }
            } else {
                // Utilisateur non connecté : suppression du localStorage
                let cart = JSON.parse(localStorage.getItem("cart")) || [];

                // Supprimer l'article correspondant à itemId
                cart = cart.filter((item) => item.productId !== itemId);

                // Mettre à jour le localStorage
                localStorage.setItem("cart", JSON.stringify(cart));

                // Dispatch de l'action Redux
                dispatch(cartRemoveItemSuccess(itemId));
            }
        } catch (error) {
            console.error("Error removing item from cart:", error);
        }
    };
}

export function cartUpdateQuantities(quantities) {
    // sending request to server, timeout is used as a stub
    return async (dispatch, getState) => {
        const state = getState();
        const token = state?.user.userConnected.accessToken;
        const userId = state?.user?.userConnected?.user?.id;
        if (!token) {
            dispatch(cartUpdateQuantitiesSuccess(quantities));;
        } else {
            try {
                const response = await api.put(
                    "cart/update",
                    { userId, quantities },
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );

                if (response.status === 200) {
                    dispatch(cartUpdateQuantitiesSuccess(quantities));
                }
            } catch (error) {
                console.error("Error adding item to cart:", error);
            }
        }
    };
}

export const clearCart = () => ({
    type: CLEAR_CART,
});

